"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportSalesOrdersResponse = void 0;
const import_sales_orders_progress_response_1 = require("./import-sales-orders-progress.response");
class ImportSalesOrdersResponse {
}
exports.ImportSalesOrdersResponse = ImportSalesOrdersResponse;
//# sourceMappingURL=import-sales-orders.response.js.map